import { Formik, Form, Field } from 'formik';
import { Button, Grid } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import {
  EditorState,
  ContentState,
  convertFromRaw,
  convertToRaw,
} from 'draft-js';

import { SCHEMATIC_COMMENT_FORM_VALUES } from 'features/wells/schematics/helpers/constants';
import EditorFormik from 'app/components/form/formik/EditorFormik';
import { useState } from 'react';
import { useEffect } from 'react';

const SchematicCommentForm = ({
  handleSubmit,
  handleCancel,
  initialValues,
  isEdit,
  isFetching,
  classes,
}) => {
  const isJson = (value) => {
    try {
      JSON.parse(value);
    } catch (e) {
      return false;
    }
    return true;
  };
  const getEditorContent = (content) => {
    if (isJson(content)) {
      return EditorState.createWithContent(convertFromRaw(JSON.parse(content)));
    }
    if (typeof content === 'string') {
      return EditorState.createWithContent(
        ContentState.createFromText(content),
      );
    }
    return EditorState.createEmpty();
  };
  const { comment } = initialValues;
  const [editorState, setEditorState] = useState(getEditorContent(comment));

  const formatEditorValue = (value) => {
    if (value instanceof EditorState) {
      return value;
    }
    return getEditorContent(value);
  };

  const placeCursorAtEnd = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const lastBlock = contentState.getBlockMap().last();
    if (!lastBlock) return editorState;

    const key = lastBlock.getKey();
    const length = lastBlock.getLength();
    const newSelection = editorState.getSelection().merge({
      anchorKey: key,
      anchorOffset: length,
      focusKey: key,
      focusOffset: length,
      hasFocus: true,
    });

    return EditorState.forceSelection(editorState, newSelection);
  };

  const handleEditorChange = () => {
    setEditorState((prevState) => {
      return placeCursorAtEnd(prevState);
    });
  };

  const handleEditorFocus = () => {
    setTimeout(() => {
      setEditorState((prevState) => placeCursorAtEnd(prevState));
    }, 10);
  };

  const onSubmit = (values) => {
    handleSubmit(
      JSON.stringify(
        convertToRaw(
          values[SCHEMATIC_COMMENT_FORM_VALUES.COMMENT].getCurrentContent(),
        ),
      ),
    );
  };

  useEffect(() => {
    setEditorState(getEditorContent(comment));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment]);

  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={{
        [SCHEMATIC_COMMENT_FORM_VALUES.COMMENT]: editorState,
      }}
    >
      {() => (
        <Form className={classes.form}>
          <Grid item xs={6} className={classes.textEditorWrapper}>
            <Field
              value={editorState}
              onChange={handleEditorChange}
              format={formatEditorValue}
              name={SCHEMATIC_COMMENT_FORM_VALUES.COMMENT}
              label="Comment"
              className={classes.textfieldLabel}
              component={EditorFormik}
              xs={12}
              editorXS={12}
              disabled={!isEdit}
              editorMarginTop={0}
              generalMarginTop={0}
              isRisk
              onEditorFocus={handleEditorFocus}
            />
          </Grid>
          {isEdit ? (
            <Grid item xs={6} className={classes.buttonsWrapper}>
              <Button onClick={handleCancel} variant="text">
                Cancel
              </Button>
              <Button
                disabled={isFetching}
                onClick={() => {}}
                color="primary"
                variant="contained"
                type="submit"
              >
                Save version
              </Button>
            </Grid>
          ) : null}
        </Form>
      )}
    </Formik>
  );
};

const styles = (theme) => ({
  form: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonsWrapper: {
    alignSelf: 'flex-end',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  textfieldLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      background: theme.palette.background.default,
    },
  },
  textEditorWrapper: {
    '& .public-DraftStyleDefault-block': {
      marginTop: 0,
    },
    height: '180px',
    paddingBottom: '28px',
    overflowY: 'none',
  },
});

export default withStyles(styles)(SchematicCommentForm);
